<h6>
    <span class="f-14 text-underline cursor-pointer text-logo-blue" (click)="onClick()">{{field.templateOptions.sectionHeading}}</span> 
    <span class="f-14 cursor-pointer font-weight-bold color-red" *ngIf="userType==5 && count==0"> {{'no_forms_selected' | translate }}</span>
    <span class="f-14 cursor-pointer font-weight-bold color-orange" *ngIf="userType==5 && count>0"> {{count}} {{'forms_required' | translate }}</span>
       
</h6>